module.exports = __webpack_public_path__ + "img/visa-platinum.b1762a2f.png";